import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'companyCareerFunctionLabel',
})
export class CompanyCareerFunctionLabelPipe implements PipeTransform {

  transform(value: string | undefined | null, mode: 'append' | 'strip' = 'append'): string {
    if (!value) {
      return '';
    }

    const suffix = ' (Bedrijfseigen functie)';
    const strippedValue = value.toLowerCase().endsWith(suffix.toLowerCase())
      ? value.slice(0, -suffix.length).trimEnd()
      : value;

    if (mode === 'strip') {
      return strippedValue;
    }

    return `${strippedValue}${suffix}`;
  }

}
